namespace CMS {

    interface IMetaData extends ng.IScope {
        title : string;
        description : string;
        keywords : string;
        robots : string;
    }

    angular.module('cms').directive('seoMetaData', function() {
        return {
            scope: {
                title : '@',
                description : '@',
                keywords : '@',
                robots : '@'
            },
            replace : false,
            link : function(scope : IMetaData, el, attr) {
                let tags :any = {},
                    head = $('head');

                if (scope.title) {
                    tags.title = `<title>${scope.title}</title>`;
                    tags['meta[name=title]'] = `<meta name='title' content='${scope.title}'/>`;
                }
                if (scope.description) {
                    tags['meta[name=description]'] = `<meta name='description' content='${scope.description}'/>`;
                }
                if (scope.keywords) {
                    tags['meta[name=keywords]'] = `<meta name='keywords' content='${scope.keywords}'/>`;
                }
                if (scope.robots) {
                    tags['meta[name=robots]'] = `<meta name='robots' content='${scope.robots}'/>`;
                }

                $.each(tags, (selector, html) => {
                    $(selector).remove();
                    head.append(html);
                });
            }
        };
    });
}
